/** @format */

export const displayDistance = (value, asSeparated = false) => {
  const processDistance = () => {
    const formatResponse = (calculatedValue, unit) => {
      if (asSeparated) {
        return {
          value: calculatedValue,
          unit
        };
      } else {
        return `${calculatedValue} ${unit}`;
      }
    };

    if (value >= 1000) {
      return formatResponse((value / 1000).toFixed(2), 'km');
    } else {
      return formatResponse(value, 'm');
    }
  };

  if (value && !isNaN(value)) {
    return processDistance();
  }
  return null;
};

export const displayYesOrNull = (value) => {
  if (value) {
    return 'JA';
  }

  return null;
};

export const FACTS_FIELD_KEYS = {
  DOCUMENTS: 'documents',
  ASSESSMENTS: 'assessments',
  ENROLLMENTS: 'enrollments',
  PLAN: 'plan',
  ENERGY_DECLARATION: 'energyDeclaration',
  BALCONY_PATIO: 'balconyPatio',
  PARTICIPATION_REPAIR_FUND: 'participationAndRepairFund',
  ASSOCIATION: 'association',
  PLOT: 'plot',
  AREA: 'area',
  OPERATIONS: 'operation',
  INTERIOR: 'interior',
  FLOOR_AND_ELEVATOR: 'floorAndElevator',
  ENVIRONMENT: 'environment',
  BUILDING: 'building',
  EXTERIOR: 'exterior',
  DISTANCES: 'distances',
  BASE_INFO: 'baseInfo',
  CHARGE: 'charge',
  COMPILATION_OF_AREAS: 'compilationAreas',
  INSURANCE: 'insurance',
  ELECTRICITY: 'electricity'
};
